module.exports = __webpack_public_path__ + "img/girl-green-eyes.1d2a9c3d.jpg";